import { NSModal } from 'bricks';

export interface IImportUsesModalProps {
    isOpen: boolean;
    toggle: () => void;
    handleDeleteBudgetCategories: () => void;
    isLoading: boolean;
}

const ImportUsesModal = ({
    isOpen, toggle, handleDeleteBudgetCategories, isLoading,
}: IImportUsesModalProps) => (
    <NSModal
        isOpen={isOpen}
        toggle={toggle}
        modalHeaderText={<h5 className="font-weight-bold">Import via different method</h5>}
        modalHeaderClassName="text-white bg-danger"
        modalFooterButtonText="Confirm"
        modalFooterButtonColor="danger"
        modalFooterButtonFunction={handleDeleteBudgetCategories}
        modalFooterButtonIsLoading={isLoading}
    >
        <div className="text-dark h5 mb-0">Are you sure you want to return to the import selection step?</div>
        <div className="h6 mt-1">This will override any existing data you've entered and will not save your work.</div>
    </NSModal>
);

export default ImportUsesModal;
